module.exports = __webpack_public_path__ + "media/images/soar/Adicionando_topicos-a4e1180bb2f8502e556dc50276c5ced1.gif";